/**
 * ListViewSchema for Item Price DocType
 * 
 * Schema-driven configuration for Item Price list page.
 * 
 * This schema replaces hardcoded column definitions and default filters.
 * All list layout changes should be made in this file.
 */

import type { ListViewSchema } from "./types";

export const itemPriceListViewSchema: ListViewSchema = {
  doctype: "Item Price",
  views: {
    experience: {
      columns: [
        {
          fieldname: "name",
          label: "Name",
          width: 200,
          align: "left",
          type: "Data",
          sortable: true,
        },
        {
          fieldname: "item_code",
          label: "Item Code",
          width: "grow",
          align: "left",
          type: "Link",
          sortable: true,
        },
        {
          fieldname: "price_list",
          label: "Price List",
          width: 160,
          align: "left",
          type: "Link",
          sortable: true,
        },
        {
          fieldname: "currency",
          label: "Currency",
          width: 80,
          align: "center",
          type: "Data",
          sortable: true,
          hideOnMobile: true,
        },
        {
          fieldname: "price_list_rate",
          label: "Rate",
          width: 140,
          align: "right",
          type: "Currency",
          sortable: true,
        },
        {
          fieldname: "valid_from",
          label: "Valid From",
          width: 140,
          align: "left",
          type: "Date",
          sortable: true,
          hideOnMobile: true,
        },
        {
          fieldname: "valid_upto",
          label: "Valid Upto",
          width: 140,
          align: "left",
          type: "Date",
          sortable: true,
          hideOnMobile: true,
        },
      ],
      defaultSort: {
        fieldname: "modified",
        direction: "desc",
      },
      defaultFilters: [],
      quickFilters: [
        {
          id: "all",
          label: "All",
          filters: [],
          default: true,
        },
        {
          id: "selling",
          label: "Selling",
          filters: [["selling", "=", 1]],
        },
        {
          id: "buying",
          label: "Buying",
          filters: [["buying", "=", 1]],
        },
      ],
      pageSizeOptions: [20, 50, 100, 200, 400, 500],
    },
  },
};

